import AbsComponent from "../../components/AbsComponent";

export default class TemplSpell extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);
    }

    loadData(_id, _option, _callback){
        this.loading = jQuery('.swiper-wrapper .nc-community-loader');
        let state = this.store.getState(); 

        this.loading.addClass('is-show').show();
        $(this.el).hide();

        axios( {
            method: 'GET',
            url: `${state.config.apiDomain}/game/spells/${_id}`,
            withCredentials: (window.isLoginFlag === 'true'),
            params: { locale: state.config.locale }
        })
        .then( (_res) => {
            this.render(_res.data);
            _callback(this.name);
        })
        .catch( (error, d) => console.log(error,'load----', d) )
        .then( (d) => {
            this.loading.removeClass('is-show').hide();
        } );
    }

    render(it = {}){
        
        let isShowLearnItem = false;
        if (it.learnItemList?.length>0) {
            it.learnItemList.map(ma=>{
                if (ma.itemName) isShowLearnItem = true;
            })
        }

        let isShowInvokItem = it.invokeItemList?.length>0;

        const l10n = this.store.getState().config.l10n;

        const buffEffectListTmpl = getBuffEffectListTmpl(it.buffEffectList, l10n);

        this.templ = `
        <div class="gameinfo-detail__list" data-type="spell">
                <div class="gameinfo-detail__left">
                <section class="summary">
                    <img class="thumb" src="${it.image}" onerror="this.src='${this.store.getState().defaultThumb}';">
                    <div class="spec">
                        <strong class="name" data-itemgrade="${it.gradeId}">${it.name}</strong>
                        <div class="ability">
                            <span class="value" title="${it.spellTypeName}">${it.spellTypeName}</span>
                            ${!it.group? ``:`
                            <span class="value" title="${it.group}">${it.group}</span>
                            `}
                        </div>
                    </div>
                    <button class="btn-favorite${it.favorite?' is-active':''}" data-info="spells_${it.id}"><i></i> Favorite</button>
                </section>
                <section class="attribute">
                    <header>
                        <h3>${l10n['spell.spellInfo']}</h3>
                        <button class="btn-folder is-active"></button>
                    </header>
                    <article class="is-active">
                        <ul>
                            ${!it.learnLimitClassList? ``:`
                            <li>
                                <div class="key">${l10n['spell.class']}</div>
                                <div class="value">${it.learnLimitClassList.map(it=>it.className).join(' / ')}</div>
                            </li>
                            `}
                            ${!it.elementalType? ``:`
                            <li>
                                <div class="key">${l10n['spell.filter.property']}</div>
                                <div class="value">${it.elementalType}</div>
                            </li>
                            `}
                            ${!it.effectDescription? ``:`
                            <li>
                                <div class="key">${l10n['spell.description']}</div>
                                <div class="value">${it.effectDescription.replace(/\n/gi, '<br>')}</div>
                            </li>
                            `}
                            ${!it.weaponTypeList? ``:`
                            <li>
                                <div class="key">${l10n['spell.CastableWeapon']}</div>
                                <div class="value">${it.weaponTypeList.map(we=>we.name).join(' / ')}</div>
                            </li>
                            `}
                            ${buffEffectListTmpl}
                            ${!it.castRangeDisplay && !it.detailInformation?.displayValue? ``:`
                            <li>
                                <div class="key">${l10n['spell.targetArea']}</div>
                                <div class="value">
                                    ${!it.castRangeDisplay? ``: `${it.castRangeDisplay}<br>`}
                                    ${!it.detailInformation?.displayValue? ``: `${it.detailInformation?.displayValue}`}
                                </div>
                            </li>
                            `}
                            <li>
                                <div class="key">${l10n['spell.cooldown']}</div>
                                <div class="value">${it.castDelayDisplay?it.castDelayDisplay: l10n['common.none']}</div>
                            </li>
                            <li>
                                <div class="key">${l10n['spell.consumption']}</div>
                                <div class="value">
                                    ${(!it.hpCost && !it.mpCost && !it.spellMaterialItem)? l10n['common.none']:`
                                    ${!it.hpCost? ``: `HP ${it.hpCost}<br>`}
                                    ${!it.mpCost? ``: `MP ${it.mpCost}<br>`}
                                    ${!it.spellMaterialItem? ``: it.spellMaterialItemDisplay}
                                    `}
                                </div>
                            </li>
                            ${!it.specialResistanceType?``:`
                            <li>
                                <div class="key">${l10n['spell.applicableResistance']}</div>
                                <div class="value">${it.specialResistanceType}</div>
                            </li>
                            `}
                            ${!it.sideEffect && !it.sideDisplayBuffDuration? ``:`
                            <li>
                                ${it.spellTransformable? `
                                    <div class="key">${l10n['spell.enchantEffect']}</div>
                                `: `
                                    <div class="key">${l10n['spell.additionalEffect']}</div>
                                `}
                                <div class="value">
                                    ${it.spellTransformable && it.sideEffect? `<button data-detailshow="spell_${it.spellTransformId}">${it.sideEffect}</button>`: ``}
                                    ${!it.spellTransformable && it.sideEffect? it.sideEffect: ``}
    
                                    ${it.sideEffect && it.sideDisplayBuffDuration?`<br>`:``}
                                    ${it.sideDisplayBuffDuration? it.sideDisplayBuffDuration: ''}
                                </div>
                            </li>
                            `}
                        </ul>
                    </article>
                </section>
            </div>
            <div class="gameinfo-detail__right">
                <section class="learntypes">
                    <header>
                        <h3>${l10n['spell.howObtain']}</h3>
                        <button class="btn-folder is-active"></button>
                    </header>
                    <article class="is-active">
                        ${(!isShowLearnItem && !it.polymorphSpell && !isShowInvokItem)? `<p>${l10n['common.unknown']}</p>`: `
                        <ul>
                            ${!isShowLearnItem?``:`
                            <li>
                                <div class="key">${l10n['spell.magicBook']}</div>
                                <div class="value">
                                    ${it.learnItemList.map(ma=>{
                                        if (!ma.itemName) return '';
                                        return `
                                        <p>
                                            <button data-detailshow="item_${ma.itemId}" data-itemgrade="${ma.gradeId}" data-id="${ma.itemId}">
                                                ${ma.itemName}
                                                ${ma.tradable? ``: `<span class="tradable" title="${l10n['item.bound']}"></span>`}
                                            </button>
                                        </p>`;
                                    }).join('')}
                                </div>
                            </li>
                            `}
                            ${!it.polymorphSpell?``:`
                            <li>
                                <div class="key">${l10n['spell.transformationSpell']}</div>
                                <div class="value">
                                    ${it.polymorphList.map(pl=>`
                                    <p>
                                        <button data-detailshow="polymorph_${pl.id}" data-itemgrade="${pl.gradeId}">
                                            ${pl.name}
                                        </button>
                                    </p>`).join('')}
                                </div>
                            </li>
                            `}
    
                            ${!isShowInvokItem?``:`
                            <li>
                                <div class="key">${l10n['spell.trigger']}</div>
                                <div class="value">
                                    ${it.invokeItemList.map(il=>`
                                    <p>
                                        <button data-detailshow="item_${il.itemId}" data-itemgrade="${il.gradeId}">
                                            ${il.itemName}
                                            ${il.tradable? ``: `<span class="tradable" title="${l10n['item.bound']}"></span>`}
                                        </button>
                                    </p>`).join('')}
                                </div>
                            </li>
                            `}
                        </ul>
                        ` }
                    </article>
                </section>
            </div>
        </div>`;

        $(this.el).show();
        $(this.el).html( this.templ );
    }

} // end of class

function getBuffEffectListTmpl(buffEffectList = [], l10n = {}) {
    if(!buffEffectList?.length) return '';

    const validItems = buffEffectList.filter((it) => !(it.displayValue || '').split(' ').includes('null'));
    if(!validItems.length) return '';

    return `
    <li>
        <div class="key">${l10n['spell.effect']}</div>
        <div class="value">
            ${validItems.map(it => `${it.displayValue}<br>`).join('')}
        </div>
    </li>`;
}

/* 

    ${(!it.learnItemList?.length>0 && !it.polymorphSpell && !it.itemSpell)? `<p>${l10n['common.unknown']}</p>`: `


    ${!it.itemSpell?``:`
    <li>
        <div class="key">${l10n['spell.trigger']}</div>
        <div class="value">
            <p data-itemgrade="epic">???아이템목록필요???</p>
        </div>
    </li>
    `}
    ${it.polymorphList.map(pl=>`<p><button data-detailshow="polymorph_${pl.id}" data-itemgrade="${pl.gradeId}" data-id="${pl.itemId}">${pl.name}</button></p>`).join('')}

*/